/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_WindowsInputs */

const en_home_hero_cta_windows = /** @type {(inputs: Home_Hero_Cta_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows`)
};

/**
* | output |
* | --- |
* | "Download for Windows" |
*
* @param {Home_Hero_Cta_WindowsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_cta_windows = /** @type {((inputs?: Home_Hero_Cta_WindowsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_WindowsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_cta_windows(inputs)
});
export { home_hero_cta_windows as "home.hero.cta_windows" }